import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { defaultOrgId } from '@app/helpers';
import { IActiveFilter, IProvisioningPolicy, IProvisioningPolicyElement } from '@app/models';

class ProvisioningPoliciesService {
    readonly apiBase: string = '/api/directory/ProvisioningPolicies';

    getProvisioningPolicies(orderBy: string, asc: string, top: number, skip: number, isReset: boolean, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(`${this.apiBase}`, {
            params: {
                $orderBy: orderBy + ' ' + asc,
                $top: top,
                $skip: skip,
                $count: isReset,
                ...(filters ? { $filter: manageFilters(filters, defaultOrgId) } : { $filter: manageFilters([], defaultOrgId)})
            }
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getProvisioningPoliciesDTO(): AxiosPromise {
        // Provisioning Policies only exist in the default org
        return apiService.get(`${this.apiBase}/ProvisioningPoliciesDTO?$filter=OrganizationId eq ${defaultOrgId}`, {
            params: {
                $orderBy: 'DisplayName asc',
            }
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getPolicyById(policyId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}(${policyId})`,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    addNewPolicy(jsonObject: IProvisioningPolicy, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(this.apiBase,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    updatePolicyElements(policyId: string, jsonObject: IProvisioningPolicyElement[], handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${policyId})/UpdateElements`,
            { elements: jsonObject },
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    updatePolicy(policyId: string, jsonObject: IProvisioningPolicy, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.patch(`${this.apiBase}(${policyId})`,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    deletePolicy(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/DeletePolicies`,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }
}

export const provisioningPoliciesService = new ProvisioningPoliciesService();